import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'idp-registration-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './registration-layout.component.html',
  styleUrl: './registration-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationLayoutComponent {}
